import React, { useEffect, useState } from 'react';

import { Box, Button, Typography, Stack } from '@mui/material';
import { useFormik, FormikHelpers } from 'formik';

import TextField from './InputField';
import { useModalStyles } from '../../../../auth/hooks/useModalStyles';

import { useStyles } from './styles';
import FilesService from '../../../../../../services/FilesService';
import { useFeedbackModal } from '../context/context';
import { useMytaverseEvent } from '../../../../../../modules/dashboard/providers/MytaverseEventProvider/MytaverseEventProvider';

const FeedbackForm = () => {
  const modalClasses = useModalStyles();

  const classes = useStyles();

  const [isSubmitted, setIsSubmitted] = useState(false);
  const { open } = useFeedbackModal();

  const { currentParticipant } = useMytaverseEvent();

  const onSubmit = async (
    values: any,
    { setSubmitting }: FormikHelpers<any>,
  ) => {
    setSubmitting(true);

    try {
      await FilesService.saveFormData({
        name: `feedback-${currentParticipant?.participantId}`,
        formData: JSON.stringify(values),
      });

      setIsSubmitted(true);
    } catch (e) {
      console.log(e);
    } finally {
      setSubmitting(false);
    }
  };

  const {
    values,
    touched,
    handleSubmit,
    handleChange,
    resetForm,
    isSubmitting,
    errors,
    setFieldTouched,
  } = useFormik({
    initialValues: {
      q1: '',
      q2: '',
      q3: '',
      q4: '',
      q5: '',
      q6: '',
      q7: '',
      q8: '',
      q9: '',
      q10: '',
    },
    onSubmit,
    enableReinitialize: true,
  });

  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open]);

  if (isSubmitted) {
    return <Typography>Thanks for your feedback!</Typography>;
  }

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={classes.root}>
        <TextField
          name="q1"
          value={values.q1}
          label={'Q1'}
          placeholder={'Q1'}
          onChange={handleChange}
        />
        <Stack sx={classes.fieldGroup}>
          <Typography>Long Question To Answer</Typography>
          <TextField
            name="q2"
            value={values.q2}
            onChange={handleChange}
            placeholder={'Q2'}
          />
        </Stack>

        <TextField
          name="q3"
          value={values.q3}
          label={'Q3'}
          placeholder={'Q3'}
          onChange={handleChange}
        />
        <TextField
          name="q4"
          value={values.q4}
          label={'Q4'}
          placeholder={'Q4'}
          onChange={handleChange}
        />
        <TextField
          name="q5"
          value={values.q5}
          label={'Q5'}
          placeholder={'Q5'}
          onChange={handleChange}
        />
        <TextField
          name="q6"
          value={values.q6}
          label={'Q6'}
          placeholder={'Q6'}
          onChange={handleChange}
        />
        <TextField
          name="q7"
          value={values.q7}
          label={'Q7'}
          placeholder={'Q7'}
          onChange={handleChange}
        />
        <TextField
          name="q8"
          value={values.q8}
          label={'Q8'}
          placeholder={'Q8'}
          onChange={handleChange}
        />
        <TextField
          name="q9"
          value={values.q9}
          label={'Q9'}
          placeholder={'Q9'}
          onChange={handleChange}
        />
        <TextField
          name="q10"
          value={values.q10}
          label={'Q10'}
          placeholder={'Q10'}
          onChange={handleChange}
        />
        <Button
          sx={{ ...modalClasses.button, ...modalClasses.buttonPrimary }}
          color="primary"
          variant="contained"
          fullWidth
          type="submit"
          disabled={isSubmitting}
        >
          Submit
        </Button>
      </Box>
    </form>
  );
};

export default FeedbackForm;
